/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import { graphql, useStaticQuery } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import { Helmet } from "react-helmet"

const keywords = `
Legal,​Online dispute resoution ​,	
Arbitration 	,
Mediation 	,
ODR	,
RV	,
Complaint,	
Resolve	,
Settlement	,
Agreement	,
Respondent	,
Settlement Agreement,​	
Claimant,	
Arbitral award,	
Legal	,
Law	,
Consumer Dispute	,
Consumer Cort	,
Court	,
Online court,	
settle	,
Negotiation	,
Conciliation,	
Reconciliation	,
Case	,
File	,
Issue	,
India	,
CPA 2019	,
Consumer Protection Act,	
Consumer law	,
file a case	,
find a lawyer,	
mediators in india,	
mediators in delhi	,
mediators in kolkata,	
mediators in bangalore,	
mediators in mumbai	,
domain	,
dispute	,
cases	,
relationship dispute,	
property dispute,	
odrways	,
odrways domain,	
lawyers	,
future of justice system,	
disruptive start up	,
disruptive startup	,
next big thing	,
legal startup	,
law and technology	,
disruptive	,
disruptio	,
Vendor	,
Consumer court,	
Legal tech	,
Service	,
justice for all,	
E-commerce	,
Banking	,
Finance	,
Travel	,
Tourism	,
Hospitality	,
F&B	,
Pleadings,	
Speedy	,
Mediation Rooms,	
Live Support	,
Digital Court Ecosystem,	
B2B	,
B2C	,
secure,	
private,	
confidential,	
Experts	,
Legal Expertise,	
Document Automation,	
Accessible	,
`

function SEO({ description, lang, meta, title, ogImage, ogDescription }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            url
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  const siteUrl = site.siteMetadata.url

  console.log(siteUrl)

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      link={[
        {
          rel: "stylesheet",
          href:
            "https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.0.0/animate.min.css",
        },
      ]}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `keywords`,
          content: keywords.replace(/\s+/g, ""),
        },
        { name: "og:url", content: siteUrl },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: ogDescription,
        },
        {
          property: `og:image`,
          content: ogImage,
        },
        {
          property: `og:type`,
          content: `website`,
        },

        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
